var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6099",
    "data-name": "Grupo 6099",
    transform: "translate(0 -816)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2309",
    "data-name": "Ret\\xE2ngulo 2309",
    width: 88,
    height: 88,
    rx: 20,
    transform: "translate(0 816)",
    fill: "#b4eaf0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "text_snippet_50dp_5F6368",
    transform: "translate(17 833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2308",
    "data-name": "Ret\\xE2ngulo 2308",
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8562",
    "data-name": "Caminho 8562",
    d: "M42.9,15.4,31.829,4.329A4.579,4.579,0,0,0,28.6,3H7.583A4.6,4.6,0,0,0,3,7.583V39.667A4.6,4.6,0,0,0,7.583,44.25H39.667a4.6,4.6,0,0,0,4.583-4.583V18.652A4.6,4.6,0,0,0,42.9,15.4ZM12.167,12.167H28.208V16.75H12.167ZM35.083,35.083H12.167V30.5H35.083Zm0-9.167H12.167V21.333H35.083Z",
    transform: "translate(3.875 3.875)",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.71ad65ad.svg";
export { ForwardRef as ReactComponent };